export class PreguntaBase<T>{

  value: T;
  key: string;
  label: string;
  required: boolean;
  selected: number;
  order: number;
  controlType: string;
  descripcion: string;

  constructor(options: {
      value?: T,
      key?: string,
      label?: string,
      required?: boolean,
      selected?: number,
      order?: number,
      controlType?: string
    } = {}) {

    this.value = options.value;
    this.key = options.key || '';
    this.label = options.label || '';
    this.required = !!options.required;
    this.selected = options.selected;
    this.order = options.order === undefined ? 1 : options.order;
    this.controlType = options.controlType || '';
    this.descripcion ='';

  }

}



// WEBPACK FOOTER //
// ./src/app/_models/preguntabase.model.ts